import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AutotextService } from 'src/app/autotext.service';
import { ExamsService } from 'src/app/exams.service';
import { UsgService } from 'src/app/usg.service';
import { LoginService } from 'src/app/login.service';
import { AngularEditorConfig } from "@kolkov/angular-editor";


@Component({
    selector: 'app-endoscopy-summary',
    templateUrl: './endoscopy-summary.component.html',
    styleUrls: ['./endoscopy-summary.component.scss'],
    standalone: false
})
export class EndoscopySummaryComponent implements OnInit, OnDestroy {
  private sub = new Subscription();
  editorConfig: AngularEditorConfig = {
    editable: true,
    height: "fit-content",
    toolbarHiddenButtons: [
      ["subscript", "superscript", "strikeThrough"],
      [
        "backgroundColor",
        "customClasses",
        "link",
        "unlink",
        "insertImage",
        "insertVideo",
        "removeFormat",
        "toggleEditorMode",
      ],
    ],
  };
  constructor(
    public es: ExamsService,
    public gs: UsgService,
    public ls: LoginService,
    public atS: AutotextService
  ) {}

  ngOnInit(): void {
    this.sub = this.es.formLoaded$.subscribe(() => {
      if (this.es.isClosed) {
        this.gs.gastroForm.disable({ emitEvent: false });
      }
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}